<template>
  <div class="card">
    <div class="card-header">
      <h3>{{ title }}</h3>
    </div>

    <card-row
      propName="Revenue"
      :propValue="advancedStatsData.revenue | numeralFormat('($0.000a)').toUpperCase()"
      :hasBorder="true"
      v-tooltip.top-center="revenue"
    />
    <card-row
      propName="Gross Profit"
      :propValue="advancedStatsData.grossProfit| numeralFormat('($0.000a)').toUpperCase()"
      :hasBorder="true"
      v-tooltip.top-center="grossProfit"
    />
    <card-row
      propName="Total Revenue"
      :propValue="advancedStatsData.totalRevenue | numeralFormat('($0.000a)').toUpperCase() "
      :hasBorder="true"
      v-tooltip.top-center="totalRevenue"
    />
    <card-row
      propName="EBITDA"
      :propValue="advancedStatsData.EBITDA | numeralFormat('($0.000a)').toUpperCase()"
      :hasBorder="true"
      v-tooltip.top-center="ebitda"
    />
    <card-row
      propName="Enterprise Value"
      :propValue="advancedStatsData.enterpriseValue | numeralFormat('($0.000a)').toUpperCase()"
      :hasBorder="true"
      v-tooltip.top-center="enterpriseValue"
    />
    <card-row
      propName="Total Cash"
      :propValue="advancedStatsData.totalCash | numeralFormat('($0.000a)').toUpperCase()"
      :hasBorder="true"
      v-tooltip.top-center="totalCash"
    />
    <card-row
      propName="Revenue Per Share"
      :propValue="advancedStatsData.revenuePerShare | numeralFormat('($0,0)').toUpperCase()"
      :hasBorder="true"
      v-tooltip.top-center="revenuePerShare"
    />
    <card-row
      propName="Debt to Equity"
      :propValue="advancedStatsData.debtToEquity"
      :hasBorder="true"
      v-tooltip.top-center="debtToEquity"
    />
    <card-row
      propName="Profit Margin"
      :propValue="advancedStatsData.profitMargin | numeralFormat('0.000')"
    />
  </div>
</template>
<script>
import CardRow from "./../utils/CardRow";

export default {
  name: "KeyStats",
  components: { CardRow },
  props: { statsData: Object, advancedStatsData: Object, title: String },
  data() {
    return {
      revenue:
        "Revenue is the total amount of income generated by the sale of goods or services related to the company's primary operations",
      grossProfit:
        "Gross profit is the profit a company makes after deducting the costs associated with making and selling its products, or the costs associated with providing its services.",
      totalRevenue:
        "Total revenue is the amount of total sales of goods and services. It is calculated by multiplying the amount of goods and services sold by the price of the goods and services.",
      ebitda:
        "EBITDA, or earnings before interest, taxes, depreciation and amortization, is a measure of a company's overall financial performance and is used as an alternative to simple earnings or net income in some circumstances.",
      enterpriseValue:
        "Enterprise value (EV) is a measure of a company’s total value, often used as a more comprehensive alternative to equity market capitalization",
      totalCash: "Cash on hand",
      revenuePerShare: "Amount of revenue over common shares outstanding",
      debtToEquity:
        "The debt-to-equity (D/E) ratio is calculated by dividing a company’s total liabilities by its shareholder equity"
    };
  }
};
</script>
<style>
.card-header {
  border-bottom: 1px solid rgba(25, 29, 45, 1);
  padding: 1em;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/statistics/KeyStats.vue